export default __webpack_public_path__ + "images/8ac3e6034b60665db759a09bf5714204.svg";